import React, { useEffect, useState, useRef } from "react";
import styled, { keyframes } from "styled-components";
import { Loader } from "semantic-ui-react";
import Typewriter from "typewriter-effect";
import { useParams } from "react-router-dom";

import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { SG_GET_CHAT_GPT_SUMMARY, CLEAR_CHAT_GPT_SUMMARY } from "constants/actions";
import Logo from "assets/images/Ilogo.svg";
import {words} from '../translations'

import SkipModal from "../Components/SkipModal";
import { followupAiTypeQuestion } from "constants/questionTypes";

const Follow_up = ({
  currentQuestionDet,
  saveUpdatedAnswers,
  language,
  refQues,
  handleNext,
  sortOrder,
}) => {
  const dispatch = useDispatch();
  const timeout = useRef(null);
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(true);
  const [question, setQuestion] = useState("");
  const textareaRef = useRef();
  const [feedbackText, setFeedbackText] = useState("");
  const [open, setOpen] = useState(false);

  let { token } = useParams();

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = `${
        textareaRef.current.scrollHeight - 16
      }px`;
    }
  }, []);

  const handleInput = (e) => {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight - 16}px`;
  };

  const handleChange = (event) => {
    const newVal = event.target.value;
    setFeedbackText(newVal);
    const ResponseObj = {
      survey_q_id: currentQuestionDet.id,
      feedback: newVal,
      question_type: currentQuestionDet?.question_type,
      org_ref_ques_id: refQues?.response?.survey_q_id,
      dimension: refQues?.response?.dimension,
      factor: refQues?.response?.factor,
      fr: refQues?.response?.fr,
      es: refQues?.response?.es,
      por: refQues?.response?.por,
      id: refQues?.response?.id,
      q: refQues?.response?.q,
      ques_order: currentQuestionDet?.ques_order,
      org_ques_order: refQues?.response?.ques_order,
      question: refQues?.response?.question,
      response: refQues?.response?.response,
      reverse: refQues?.response?.reverse,
      role: refQues?.response?.role,
      type: refQues?.response?.type,
      prompt: prompt,
      clicked: true,
      prompt_question: question,
      prompt_feedback: refQues?.response?.feedback,
    };

    saveUpdatedAnswers(currentQuestionDet?.id, ResponseObj, currentQuestionDet.quesType);
  };

  const { get_chat_gpt } = useSelector(
    (state) => ({
      get_chat_gpt: state.chatgpt,
    }),
    shallowEqual
  );

  useEffect(() => {
    // Clear any previous chat GPT state when component mounts
    dispatch({
      type: CLEAR_CHAT_GPT_SUMMARY,
    });
    
    if (
      !currentQuestionDet?.response?.feedback ||
      currentQuestionDet?.response?.prompt_feedback !==
        refQues?.response?.feedback
    ) {
      SubmitChatGpt();
    } else {
      setQuestion(currentQuestionDet?.response?.prompt_question);
      setFeedbackText(currentQuestionDet?.response?.feedback);
    }
  }, []);

  useEffect(() => {
    if (get_chat_gpt?.response_pending === true) {
      timeout.current = setTimeout(() => {
        setLoading(false);
        SkipQuestion()
      }, 15000);
    }

    if (get_chat_gpt?.response_pending === false) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }
    setLoading(get_chat_gpt?.response_pending);
    if (get_chat_gpt.chat_gpt_summary?.response) {
      setQuestion(get_chat_gpt.chat_gpt_summary?.response);
    }


    if(get_chat_gpt?.chat_gpt_summary?.status == 500){
      setLoading(false);
      SkipQuestion()
    }

    return () => {
      clearTimeout(timeout.current);
    };
  }, [get_chat_gpt]);

  function SubmitChatGpt() {

       
    let _prompt = `Context:
    The following is feedback from an anonymous employee engagement survey. The feedback is a response to the following statement: ${refQues?.response?.question} \n
    Feedback:\n${refQues?.response?.feedback}\n
    Question:\nWhat follow up question would an employee engagement expert ask based on the feedback given that would help to get more context around this area, while not eliciting any feedback whatsoever that may reveal or expose individuals in the company (i.e., names, leaders, etc.). and also help to eventually generate recommendations for this organization based on employee experiences and suggestions? Make sure your response is simple enough for an 7th grader to understand, and never ask people to share examples of specific individuals or circumstances that would reduce anonymity.  Only return the question istelf. \n
    Response:\n`;

    if(language=='FR'){
      
      _prompt = `Contexte:
      Les commentaires suivants proviennent d'une enquête d'analyse culturelle. Les commentaires sont une réponse à l'énoncé suivant : ${refQues?.response?.fr? refQues?.response.fr:refQues?.response?.question} \n
      Commentaires :\n${refQues?.response?.feedback}\n 
      Question :\nQuelle question de suivi un consultant culturel de classe mondiale poserait-il sur la base des commentaires fournis qui aiderait à obtenir plus de contexte autour de ce domaine, et aussi à générer des recommandations pour cette organisation ? Assurez-vous que votre réponse est assez simple pour qu'un élève de 7ème puisse comprendre. Ne retournez que la question elle-même. \n
      Réponse :\n`
    }
    if(language=='POR'){
      _prompt = `Contexto:
      Os seguintes comentários são uma resposta à seguinte declaração: ${refQues?.response?.por ? refQues.response.por: refQues?.response?.question}  \n
      Comentários:\n${refQues?.response?.feedback}\n
      Pergunta:\nQuais perguntas de acompanhamento um consultor de cultura de classe mundial faria com base nos comentários fornecidos que ajudariam a obter mais contexto sobre este assunto, e também ajudar a gerar recomendações para esta organização? Certifique-se de que sua resposta é suficientemente simples para que um aluno de 7º grau a entenda. Retorne apenas a própria pergunta. \n
      Resposta:\n`
    }

    if(language=='ES'){

      _prompt = `Contexto:
      Los siguientes comentarios son una respuesta a la siguiente declaración: ${refQues?.response?.es ? refQues.response.es: refQues?.response?.question}  \n
      Comentarios:\n${refQues?.response?.feedback}\n
      Pregunta:\n¿Qué pregunta de seguimiento haría un consultor de cultura de clase mundial basada en los comentarios dados que ayudaría a obtener más contexto en esta área, y también ayudaría a generar recomendaciones para esta organización? Asegúrese de que su respuesta sea lo suficientemente simple para que un estudiante de 7º grado la entienda. Solo devuelva la pregunta en sí. \n
      Respuesta:\n`
    }

    if(sortOrder === 160 || sortOrder === 178){
      _prompt = `Context:
      The following is feedback from a youth sport culture survey. The feedback is a response to the following statement: ${refQues?.response?.question} \n
      Feedback:\n${refQues?.response?.feedback}\n
      Question:\nWhat follow up question would a world class culture consultant ask based on the feedback given that would help to get more context around this area, and also help to generate recommendations for this organization? Make sure your response is simple enough for an 7th grader to understand. Only return the question istelf. Keep in mind the respondant is a youth athlete.\n
      Response:\n`;

      if(language=='FR'){
        _prompt = `Contexte :
        Ce qui suit est un retour d'information d'une enquête sur la culture du sport chez les jeunes. Le retour d'information est une réponse à l'affirmation suivante : ${refQues?.response?.question} 
        
        Retour d'information :
        ${refQues?.response?.feedback}
        
        Question :
        Quelle question de suivi un consultant de classe mondiale en culture poserait-il en fonction des commentaires donnés afin d'obtenir plus de contexte sur ce domaine et d'aider à formuler des recommandations pour cette organisation ? Assurez-vous que votre réponse est suffisamment simple pour qu'un élève de 5ème puisse comprendre. Retournez uniquement la question elle-même. Gardez à l'esprit que le répondant est un jeune athlète.
        
        Réponse :\n`

      }
    }

    setPrompt(_prompt);
    dispatch({
      type: SG_GET_CHAT_GPT_SUMMARY,
      payload: {
        payload: _prompt,
        token: token,
        question_no : refQues?.response?.ques_order,
      },
    });
  }

  const handleSkip = () => {
    setOpen(true);
  };

  function SkipQuestion() {
    
    const ResponseObj = {
      survey_q_id: currentQuestionDet.id,
      feedback: "",
      dimension: refQues?.response?.dimension,
      factor: refQues?.response?.factor,
      fr: refQues?.response?.fr,
      id: refQues?.response?.id,
      q: refQues?.response?.q,
      ques_order: refQues?.response?.ques_order,
      question: refQues?.response?.question,
      response: refQues?.response?.feedback,
      reverse: refQues?.response?.reverse,
      role: refQues?.response?.role,
      type: refQues?.response?.type,
      clicked: true,
      prompt: "",
      prompt_question: "",
    };
    saveUpdatedAnswers(currentQuestionDet.id, ResponseObj, followupAiTypeQuestion);
    setOpen(false);
    
    // Clear state before moving to next question
    dispatch({
      type: CLEAR_CHAT_GPT_SUMMARY,
    });
    handleNext("forced");
    
  }

  return (
    <FeedbackContainer>
      <Title>
        <Circle>
          <IMG src={Logo} />
        </Circle>
       {words['Follow Up'][language]}
      </Title>
      <QuestionContainer>
        {loading ? (
          <Loader active inline />
        ) : (
          <FadeInText>{question}</FadeInText>
        )}
      </QuestionContainer>

      <StyledTextarea
        id={`txt_${currentQuestionDet?.id}`}
        value={feedbackText}
        onChange={handleChange}
        placeholder={words["textarea"][language]}
        ref={textareaRef}
        onInput={handleInput}
      />

      <Skip onClick={handleSkip}>{words['Skip'][language]} &gt;</Skip>
      <SkipModal open={open} setOpen={setOpen} SkipQuestion={SkipQuestion} language={language}/>
    </FeedbackContainer>
  );
};

export default Follow_up;

const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 600px;
  width: 100%;
  font-family: "Raleway", sans-serif;
`;

const QuestionContainer = styled.div`
  margin-bottom: 34px;
  width: 100%;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const FadeInText = styled.div`
  color: #2a3039;
  font-family: "Raleway";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6;
  animation: ${fadeIn} 1s ease-in;
`;

const Title = styled.div`
  color: #2d70e2;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 40px;
  display: flex;
`;

const StyledTextarea = styled.textarea`
  display: block;
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #2a3039;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  resize: none;
  font-family: "Raleway", sans-serif;

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #2d70e2;
    outline: 0;
  }
`;

const Skip = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #2d70e2;
  margin-top: 40px;
  cursor: pointer;
`;

const Circle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: #2d70e2;
  margin-right: 10px;
  min-width: 40px;
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;

const IMG = styled.img`
  width: 20px;
`;
